/**
 * Проверяет, является ли символ эмодзи
 * @param {number} code - Unicode код символа
 * @returns {boolean}
 */
function isEmoji(code) {
  return (
    // Эмоции и люди
    (code >= 0x1F600 && code <= 0x1F64F) ||
    // Разные символы и пиктограммы
    (code >= 0x1F300 && code <= 0x1F5FF) ||
    // Транспорт и символы карт
    (code >= 0x1F680 && code <= 0x1F6FF) ||
    // Флаги (региональные индикаторы)
    (code >= 0x1F1E6 && code <= 0x1F1FF) ||
    // Дополнительные символы и пиктограммы
    (code >= 0x1F900 && code <= 0x1F9FF) ||
    // Дополнительные символы и пиктограммы A
    (code >= 0x1FA70 && code <= 0x1FAFF) ||
    // Enclosed characters
    (code >= 0x1F170 && code <= 0x1F251) ||
    // Игральные карты
    (code === 0x1F004 || code === 0x1F0CF) ||
    // Основные символы (часто используемые как эмодзи)
    (code >= 0x2600 && code <= 0x26FF) ||
    // Dingbats
    (code >= 0x2700 && code <= 0x27BF) ||
    // Дополнительные dingbats
    (code >= 0x2B50 && code <= 0x2B55) ||
    // Стрелки (некоторые используются как эмодзи)
    (code >= 0x2190 && code <= 0x21FF && isArrowEmoji(code)) ||
    // Математические символы (некоторые используются как эмодзи)
    (code >= 0x2200 && code <= 0x22FF && isMathEmoji(code)) ||
    // Разные технические символы
    (code >= 0x2300 && code <= 0x23FF && isTechnicalEmoji(code)) ||
    // Enclosed alphanumerics
    (code >= 0x2460 && code <= 0x24FF) ||
    // Box drawing и block elements (некоторые)
    (code >= 0x25A0 && code <= 0x25FF && isGeometricEmoji(code))
  );
}

/**
 * Проверяет, является ли стрелка эмодзи
 */
function isArrowEmoji(code) {
  const arrowEmojis = [
    0x2194, 0x2195, 0x2196, 0x2197, 0x2198, 0x2199, // стрелки направлений
    0x21A9, 0x21AA, // изогнутые стрелки
    0x2934, 0x2935  // дополнительные стрелки
  ];
  return arrowEmojis.includes(code);
}

/**
 * Проверяет, является ли математический символ эмодзи
 */
function isMathEmoji(code) {
  const mathEmojis = [
    0x2208, 0x2209, // принадлежность множеству
    0x2212, // минус
    0x2213, 0x2214, // плюс-минус
    0x2260, 0x2264, 0x2265, // неравенства
    0x2205, // пустое множество
    0x221E, // бесконечность
    0x2211, // сумма
    0x220F, // произведение
    0x221A, // корень
    0x2248, // приблизительно равно
    0x2299, // точка в круге
    0x229A, 0x229B // операции в кругах
  ];
  return mathEmojis.includes(code);
}

/**
 * Проверяет, является ли технический символ эмодзи
 */
function isTechnicalEmoji(code) {
  const technicalEmojis = [
    0x231A, 0x231B, // часы
    0x2328, // клавиатура
    0x23CF, // кнопка воспроизведения
    0x23E9, 0x23EA, 0x23EB, 0x23EC, 0x23ED, 0x23EE, 0x23EF, // медиа кнопки
    0x23F0, 0x23F1, 0x23F2, 0x23F3, // таймеры
    0x23F8, 0x23F9, 0x23FA // дополнительные медиа кнопки
  ];
  return technicalEmojis.includes(code);
}

/**
 * Проверяет, является ли геометрическая фигура эмодзи
 */
function isGeometricEmoji(code) {
  const geometricEmojis = [
    0x25AA, 0x25AB, // маленькие квадраты
    0x25B6, // треугольник вправо
    0x25C0, // треугольник влево
    0x25FB, 0x25FC, 0x25FD, 0x25FE // большие квадраты
  ];
  return geometricEmojis.includes(code);
}

/**
 * Проверяет, нужно ли сохранить символ как есть (не кодировать)
 * @param {number} code - Unicode код символа
 * @returns {boolean}
 */
function shouldPreserveCharacter(code) {
  return (
    // ASCII
    (code >= 0x0000 && code <= 0x007F) ||
    // Расширенная латиница
    (code >= 0x0080 && code <= 0x024F) ||
    // Кириллица
    (code >= 0x0400 && code <= 0x04FF) ||
    // Дополнительная кириллица
    (code >= 0x0500 && code <= 0x052F) ||
    // Греческий и коптский (для научных текстов)
    (code >= 0x0370 && code <= 0x03FF) ||
    // Арабский (основной)
    (code >= 0x0600 && code <= 0x06FF) ||
    // Китайский, японский, корейский (базовые диапазоны)
    (code >= 0x4E00 && code <= 0x9FFF) || // CJK Unified Ideographs
    (code >= 0x3040 && code <= 0x309F) || // Hiragana
    (code >= 0x30A0 && code <= 0x30FF) || // Katakana
    (code >= 0xAC00 && code <= 0xD7AF)    // Hangul
  );
}

/**
 * Конвертирует эмодзи в Unicode escape-последовательности
 * @param {string} str - Исходная строка
 * @param {Object} options - Опции
 * @param {boolean} options.onlyEmojis - Кодировать только эмодзи (по умолчанию true)
 * @param {boolean} options.preserveText - Сохранять текстовые символы (по умолчанию true)
 * @returns {string}
 */
export function emojiToUnicodeEscapes(str, options = {}) {
  const {
    onlyEmojis = true,
    preserveText = true
  } = options;

  if (typeof str !== 'string') {
    return '';
  }
  
  if (str.length > 10000) {
    throw new Error('String too long (max 10000 characters)');
  }
  
  try {
    return [...str].map(char => {
      const code = char.codePointAt(0);
      
      // Сохраняем основные текстовые символы
      if (preserveText && shouldPreserveCharacter(code)) {
        return char;
      }
      
      // Если включен режим "только эмодзи", кодируем только эмодзи
      if (onlyEmojis) {
        if (isEmoji(code)) {
          return `\\u{${code.toString(16)}}`;
        }
        return char;
      }
      
      // В режиме "все символы" кодируем все, кроме сохраняемых
      return `\\u{${code.toString(16)}}`;
    }).join('');
  } catch (e) {
    throw new Error(`Failed to convert emojis to unicode escapes: ${e.message}`);
  }
}

/**
 * Валидирует hex-строку для Unicode
 * @param {string} hex - Hex-строка
 * @returns {boolean}
 */
function isValidUnicodeHex(hex) {
  if (!hex || typeof hex !== 'string') return false;
  
  // Проверяем формат (1-6 hex символов)
  if (!/^[0-9a-fA-F]{1,6}$/.test(hex)) return false;
  
  const code = parseInt(hex, 16);
  
  // Проверяем валидный диапазон Unicode
  if (isNaN(code) || code > 0x10FFFF) return false;
  
  // Проверяем на суррогатные пары (не валидные как отдельные символы)
  if (code >= 0xD800 && code <= 0xDFFF) return false;
  
  return true;
}

/**
 * Предварительно очищает строку от двойного экранирования
 * @param {string} str - Исходная строка
 * @param {boolean} enabled - Включена ли очистка
 * @returns {string}
 */
function preCleanString(str, enabled = true) {
  if (!enabled) return str;
  
  // Заменяет \\u{ на \u{ (только если это не тройное экранирование)
  return str.replace(/(?<!\\)\\\\u\{/g, '\\u{');
}

/**
 * Конвертирует Unicode escape-последовательности обратно в эмодзи
 * @param {string} str - Строка с escape-последовательностями
 * @param {Object} options - Опции
 * @param {boolean} options.strict - Строгий режим (по умолчанию true)
 * @param {boolean} options.preClean - Предварительная очистка (по умолчанию true)
 * @param {'preserve'|'remove'|'error'} options.onInvalidHex - Что делать с невалидными hex ('preserve' по умолчанию)
 * @returns {string}
 */
export function unicodeEscapesToEmoji(str, options = {}) {
  const {
    strict = true,
    preClean = true,
    onInvalidHex = 'preserve'
  } = options;

  if (!str || typeof str !== 'string') {
    return '';
  }
  
  if (str.length > 50000) {
    throw new Error('String too long (max 50000 characters)');
  }
  
  // Предварительная очистка
  if (preClean) {
    str = preCleanString(str, true);
  }
  
  try {
    return str.replace(/\\u\{([^}]+)\}/g, (match, hex) => {
      const cleanHex = hex.trim();
      
      if (!isValidUnicodeHex(cleanHex)) {
        console.log("Invalid Emoji Unicode Code", match)
        switch (onInvalidHex) {
          case 'remove':
            return '';
          case 'error':
            throw new Error(`Invalid hex code: ${cleanHex}`);
          case 'preserve':
          default:
            return match;
        }
      }
      
      try {
        const code = parseInt(cleanHex, 16);
        
        // В строгом режиме дополнительная проверка
        if (strict) {
          // Проверяем, что символ может быть отображен
          const char = String.fromCodePoint(code);
          if (char.length === 0) {
            return onInvalidHex === 'preserve' ? match : '';
          }
        }
        
        return String.fromCodePoint(code);
      } catch (e) {
        switch (onInvalidHex) {
          case 'remove':
            return '';
          case 'error':
            throw new Error(`Failed to convert hex ${cleanHex}: ${e.message}`);
          case 'preserve':
          default:
            return match;
        }
      }
    });
  } catch (e) {
    if (onInvalidHex === 'error') {
      throw e;
    }
    // В случае критической ошибки возвращаем исходную строку
    return str;
  }
}

/**
 * Проверяет, содержит ли строка эмодзи
 * @param {string} str - Проверяемая строка
 * @returns {boolean}
 */
export function containsEmoji(str) {
  if (typeof str !== 'string') return false;
  
  return [...str].some(char => {
    const code = char.codePointAt(0);
    return isEmoji(code);
  });
}

/**
 * Извлекает все эмодзи из строки
 * @param {string} str - Исходная строка
 * @returns {string[]} Массив найденных эмодзи
 */
export function extractEmojis(str) {
  if (typeof str !== 'string') return [];
  
  return [...str].filter(char => {
    const code = char.codePointAt(0);
    return isEmoji(code);
  });
}

/**
 * Удаляет все эмодзи из строки
 * @param {string} str - Исходная строка
 * @returns {string} Строка без эмодзи
 */
export function removeEmojis(str) {
  if (typeof str !== 'string') return '';
  
  return [...str].filter(char => {
    const code = char.codePointAt(0);
    return !isEmoji(code);
  }).join('');
}
